function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.671,
    height: 8.382,
    viewBox: "0 0 13.671 8.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 136 \\u2013 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 5 6.131 7.177L14.261 5",
    transform: "rotate(180 7.483 6.339)",
    style: {
      fill: "none",
      stroke: "#14a4c2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fillRule: "evenodd"
    },
    "data-name": "Drop Down"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropUp);
export default __webpack_public_path__ + "static/media/Drop Up.886f52529a913810ce9bfb89878c6bc3.svg";
export { ForwardRef as ReactComponent };